export const QUADRANTS = ['DO_FIRST', 'SCHEDULE', 'DELEGATE', 'ELIMINATE'] as const
export const COLOURS = ['slate', 'rose', 'amber', 'lime', 'sky', 'violet'] as const
export const STATUSES = ['active', 'completed'] as const
export const TAG_COLOURS = ['slate', 'rose', 'amber', 'lime', 'sky', 'violet'] as const

export type Quadrant = (typeof QUADRANTS)[number]
export type ItemColour = (typeof COLOURS)[number]
export type ItemStatus = (typeof STATUSES)[number]
export type TagColour = (typeof TAG_COLOURS)[number]

export const QUADRANT_META: Record<Quadrant, { title: string; subtitle: string; short: string }> = {
  DO_FIRST: { title: 'Do first', subtitle: 'Urgent · Important', short: 'Now' },
  SCHEDULE: { title: 'Schedule', subtitle: 'Important · Not urgent', short: 'Next' },
  DELEGATE: { title: 'Delegate', subtitle: 'Urgent · Not important', short: 'Delegate' },
  ELIMINATE: { title: 'Eliminate', subtitle: 'Neither urgent nor important', short: 'Never' },
}

export const MAX_TITLE = 240
export const MAX_DESCRIPTION = 10_000
export const MAX_BOARD_NAME = 100
export const MAX_TAG_NAME = 40
export const MAX_PROJECT_NAME = 100
export const MAX_PROJECT_DESCRIPTION = 10_000
export const POSITION_GAP = 1024
